export default {
  list: {
    colName: "Nome",
    colContact: "Contatto",
    colBalance: "Saldo",
    colActions: "Azioni",
    statusActive: "Attivo",
    statusInactive: "Inattivo",
    retry: "Riprova",
    emptySearch: "Nessun risultato corrisponde alla ricerca.",
    filterRole: "Ruolo",
    filterRoleAll: "Tutti",
    filterRoleSeller: "Venditori",
    filterRoleHost: "Host",
    filterRoleSalesAgent: "Agenti di commercio",
    filterRoleAdmin: "Staff",
    statusTooltipActive: "Account attivo",
    statusTooltipInactive: "Account inattivo",
    filterStatus: "Stato",
    filterAll: "Tutti",
    filterActive: "Attivi",
    filterInactive: "Inattivi",
    openRowAria: "Apri utente {{name}}",
    relevantSeller_one: "{{count}} attività",
    relevantSeller_other: "{{count}} attività",
    relevantHost_one: "{{count}} struttura",
    relevantHost_other: "{{count}} strutture",
    relevantSalesAgent_one: "{{count}} associazione",
    relevantSalesAgent_other: "{{count}} associazioni",
  },
  detail: {
    backToUsers: "Torna agli utenti",
    activate: "Attiva",
    deactivate: "Disattiva",
    statWallet: "Saldo portafoglio",
    statRevenue: "Ricavi totali",
    contactCard: "Informazioni di contatto",
    email: "Email account",
    phone: "Telefono",
    contactEmail: "Email di contatto",
    vatNumber: "Partita IVA",
    billingAddress: "Indirizzo di fatturazione",
    legalInfoCard: "Profilo legale",
    editLegalInfo: "Modifica profilo",
    cancelEditLegalInfo: "Annulla modifica",
    loadLegalInfo: "Caricamento profilo legale...",
    loadLegalInfoError: "Impossibile caricare il profilo legale",
    sendPasswordReset: "Invia email di reset password",
    toastPasswordResetSent: "Email di reset password inviata.",
    lastLogin: "Ultimo accesso",
    lastLoginNever: "Mai effettuato l'accesso",
    passwordResetActiveLink:
      "Un link di setup è ancora valido fino al {when}. Attendi la scadenza prima di inviarne un altro.",
    passwordResetCooldown:
      "Un'email di reset è stata inviata di recente. Potrai inviarne un'altra dopo il {when}.",
    transactionsTitle: "Movimenti del portafoglio",
    tabs: {
      ariaLabel: "Sezioni del profilo utente",
      overview: "Panoramica",
      activities: "Attività",
      activitiesDesc: "Esperienze di proprietà",
      structures: "Strutture",
      structuresDesc: "Case e dispositivi",
      associations: "Associazioni",
      associationsDesc: "Ambito attività e strutture",
      legal: "Legale",
      legalDesc: "Fatturazione, identità e pagamento",
      transactions: "Movimenti",
    },
    statusActive: "Attivo",
    statusInactive: "Inattivo",
    editDisplayName: "Modifica nome visualizzato",
    displayNamePlaceholder: "Nome visualizzato",
    displayNameEmpty: "Il nome visualizzato non può essere vuoto",
    toastDisplayNameUpdated: "Nome visualizzato aggiornato",
    toastDisplayNameError: "Impossibile aggiornare il nome visualizzato",
    addActivity: "Aggiungi attività",
    addHouse: "Aggiungi struttura",
    searchActivitiesPlaceholder: "Cerca attività…",
    noActivitiesMatchTitle: "Nessuna attività corrisponde",
    noActivitiesMatchDesc: "Prova un'altra ricerca o filtro di stato.",
    active: "Attiva",
    inactive: "Inattiva",
    houseRowCommission: "{{percent}}% di commissione",
    moreActions: "Altre azioni",
    shortcutsTitle: "Vai a",
  },
  createModal: {
    nameLabel: "Nome",
    emailLabel: "Email",
    phoneLabel: "Telefono di contatto",
    phonePlaceholder: "+39…",
    phoneRequired: "Inserisci un telefono di contatto",
    regionLabel: "Regione di pagamento *",
    chooseRegion: "Seleziona regione…",
    regionRequired: "Seleziona una regione di pagamento",
    inviteEmailHint:
      "Invieremo un’email di invito perché possano impostare la propria password.",
  },
  roles: {
    seller: "Venditore",
    host: "Host",
    "sales-agent": "Agente di commercio",
    admin: "Staff",
  },
  unified: {
    title: "Utenti",
    subtitle: "Venditori, host, agenti di commercio e staff in un unico elenco",
    addButton: "Aggiungi utente",
    searchPlaceholder: "Cerca per nome, email o ID...",
    loadError: "Impossibile caricare gli utenti",
    empty: "Nessun utente ancora",
    colCount: "Conteggio",
  },
  impersonate: "Impersona",
  rolePicker: {
    title: "Che tipo di utente vuoi aggiungere?",
    seller: "Venditore",
    host: "Host",
    salesAgent: "Agente di commercio",
    staff: "Staff",
    sellerDesc: "Partner che offre attrazioni, servizi o ristoranti",
    hostDesc: "Proprietario delle strutture in cui sono installati i kiosk",
    salesAgentDesc: "Guadagna commissioni su attività e strutture assegnate",
    staffDesc: "Membro del team interno con permessi configurabili",
  },
  createStaffModal: {
    title: "Aggiungi utente staff",
    namePlaceholder: "Nome del membro dello staff",
    emailPlaceholder: "staff@esempio.com",
    presetLabel: "Preset staff *",
    choosePreset: "Seleziona un preset…",
    presetRequired: "Seleziona un preset staff",
    create: "Invia invito",
    createSuccess: "Utente staff creato — email di invito inviata",
    createError: "Impossibile creare l’utente staff",
  },
  staffAccess: {
    title: "Permessi di {{name}}",
    subtitle:
      "Assegna un preset per seguirne i permessi live, oppure Personalizzato per un set di permessi individuale.",
    loading: "Caricamento permessi…",
    loadError: "Impossibile caricare i permessi staff",
    userNameFallback: "Utente staff",
    preset: "Preset staff",
    presetHint:
      "Gli utenti legati a un preset ricevono automaticamente le modifiche alla definizione. Modificare i permessi passa a Personalizzato.",
    presetCustom: "Personalizzato",
    enabledSummary: "{{count}} di {{total}} attivi",
    permissionsHintPresetBound:
      "Permessi live del preset. Cambiarne uno scollega su Personalizzato.",
    requiresPermissions: "Abilita prima questi permessi:",
    searchPermissions: "Cerca permessi o ambiti…",
    searchEmpty: "Nessun permesso corrisponde alla ricerca",
    cannotEditSelfTitle: "I tuoi permessi",
    cannotEditSelf:
      "Non puoi modificare il tuo accesso staff. Chiedi a un altro Super Admin di aggiornarlo.",
    immutableSuperTitle: "Super Admin",
    immutableSuper:
      "L’accesso Super Admin non si può modificare qui — promuovi o demoti solo via script ops (`set_super_admin.py`).",
    saveSuccess: "Permessi staff aggiornati",
    saveError: "Impossibile aggiornare i permessi staff",
    presets: {
      super_admin: "Super Admin",
      device_tech: "Tecnico dispositivi",
      data_entry: "Data entry",
      accounting: "Contabilità",
      user_management: "Gestione utenti",
    },
    scopes: {
      stats: "Saldo piattaforma",
      users: "Utenti",
      activities: "Attività",
      houses: "Strutture",
      storage: "Storage",
      devices: "Dispositivi",
      readers: "Lettori",
      bookings: "Prenotazioni",
      handshakes: "Handshake",
      customer_support: "Supporto clienti",
      partner_support: "Supporto partner",
      payments: "Pagamenti",
      alerts: "Avvisi",
      protocols: "Protocolli",
      carousel: "Carosello",
      agent_transcripts: "Trascrizioni vocali",
    },
  },
} as const;
